import dig from 'object-dig';

export default function handleDataAttributes(data){
  return {
    ...data,
    owners: dig(data, 'partner', 'owners') || null
  };
}
